import type { ReactNode } from 'react';
import { useState } from 'react';
import {
  NavigationItem,
  PageAccessibilityBar,
  PageAuthenticationBar,
  PageCorporateLogosBlock,
  PageFooterBar,
  PageHeaderBar,
  PageHeaderOrganizationBar,
  PageNavigationBar,
  PageSearchBlock,
} from '@common/Providers/GraphqlProvider/generated';

import LayoutContext from './LayoutContext';

export interface ILayout {
  layout: {
    authenticationBar?: PageAuthenticationBar;
    accessibilityBar?: PageAccessibilityBar;
    headerBar?: PageHeaderBar;
    searchBlock?: PageSearchBlock;
    navigationBar?: PageNavigationBar;
    navigationItems?: NavigationItem[];
    isNavigationLoading?: boolean;
    pageFooterBar?: PageFooterBar;
    pageCorporateLogosBlock?: PageCorporateLogosBlock;
    headerOrganizationBar?: PageHeaderOrganizationBar;
    isGrayScaled?: boolean;
    setIsGrayScaled?: (val: boolean) => void;
    isHightContrast?: boolean;
    setIsHightContrast?: (val: boolean) => void;
  };
}

type Props = {
  children: ReactNode | undefined;
  value: ILayout;
};

const LayoutProvider = ({ children, value }: Props) => {
  const [isGrayScaled, setIsGrayScaled] = useState(value.layout.isGrayScaled);
  const [isHightContrast, setIsHightContrast] = useState(value.layout.isHightContrast);

  const contextValue = {
    layout: {
      ...value.layout,
      isGrayScaled,
      setIsGrayScaled,
      isHightContrast,
      setIsHightContrast,
    },
  };

  return <LayoutContext.Provider value={contextValue}>{children}</LayoutContext.Provider>;
};

export default LayoutProvider;
